/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDiagnostic = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M22 22H2V2h2v9h2.4l2.5-5 5.2 8.2 2.4-3.2H22v2h-4.5l-3.6 4.8L9.1 10l-1.5 3H4v7h18z"
    />
  </Icon>
);
export { SvgDiagnostic as Diagnostic };
